export default __webpack_public_path__ + "static/media/1-4.be88a5fe.png";